import { DatePipe, JsonPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiServiceService } from '../api-service.service';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';

@Component({
  selector: 'app-ais140-api-res-logs',
  templateUrl: './ais140-api-res-logs.component.html',
  styleUrls: ['./ais140-api-res-logs.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    JsonPipe,
    DatePipe,
    MatIcon,
    MatTooltip,
    CommonSearchComponent,
    CommonPaginationComponent,
  ],
})
export class AIS140ApiResLogsComponent implements OnInit {
  listOfBatch = [];
  totalLength = 0;
  size = 10;
  page = 1;
  search = '';
  aeplResponseLogsForm: FormGroup = this.formBuilder.group({});
  userPermission = [];
  apiResLogView = false;

  constructor(
    public apiMicroservice: ApiServiceService,
    private formBuilder: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.setAPIResLogsForm();
    this.checkPermission();
    if (this.apiResLogView) {
      this.fetchApiResLogList();
    }
  }

  checkPermission() {
    this.userPermission = JSON.parse(
      this.apiMicroservice.decryptData(
        sessionStorage.getItem('userPermission') || '[]'
      )
    );
    this.userPermission.forEach(
      (element: {
        pageName: string;
        view: boolean;
        create: boolean;
        delete: boolean;
        update: boolean;
      }) => {
        if (
          element.pageName === 'AIS140 Ticket AEPL Response Logs' &&
          element.view === false
        ) {
          this.navigateBack();
        } else if (
          element.pageName === 'AIS140 Ticket AEPL Response Logs' &&
          element.view === true
        ) {
          this.apiResLogView = true;
        }
      }
    );
  }

  setAPIResLogsForm() {
    this.aeplResponseLogsForm = this.formBuilder.group({
      batchListSearch: new FormControl(''),
    });
  }

  fetchApiResLogList() {
    this.spinner.show();
    this.listOfBatch = [];
    this.apiMicroservice
      .getApiResLogsData(this.page, this.size, this.search)
      .subscribe((res) => {
        if (res.status) {
          this.listOfBatch = res.data.data;
          this.totalLength = res.data.totalItems;
          this.apiMicroservice.openSnackbar(res.message);
          this.spinner.hide();
        } else {
          this.apiMicroservice.openSnackbar(
            res.message ? res.message : 'Something went wrong'
          );
          this.spinner.hide();
        }
      });
  }

  onPageChange(event: number) {
    this.page = event;
    this.fetchApiResLogList();
  }

  onSizeChange(event: number) {
    this.page = 1;
    this.size = event;
    this.fetchApiResLogList();
  }

  onSearch(event: string) {
    this.page = 1;
    this.search = event;
    this.aeplResponseLogsForm
      ?.get('batchListSearch')
      ?.setValue(this.search ? this.search : '');
    this.fetchApiResLogList();
  }

  navigateBack() {
    this.apiMicroservice.back();
  }
}
